import ticketsTableDirective from './ticketsTable.directive';

const ticketsTableModule = angular.module('app.components.dataManagement.tickets.ticketsTable', [])
	.directive('clinicalDataTicketsTable', ticketsTableDirective)
	.name;

export default ticketsTableModule;
